module.exports = __webpack_public_path__ + "img/dojo.e21f3166.jpg";